import { Injectable } from '@angular/core';
import { SceneUtilsService } from './scene-utils.service';
import { StageService } from './stage.service';
declare let THREE: any;

@Injectable()
export class DistanceHelperService {
  private raycaster = new THREE.Raycaster();

  constructor(
    private sceneUtils: SceneUtilsService,
    private stage: StageService
  ) { }

  getDistanceToStair(point) {
    const direction = new THREE.Vector3(0, -1, 0);
    
    this.raycaster.ray.origin.copy(point);
    this.raycaster.ray.direction.copy(direction);

    let stairs = this.stage.getStairs();
    let steps = [];
    for (let i = 0; i < stairs.length; i++) {
      for (let j = 0; j < stairs[i].children.length; j++) {
        for (let k = 0; k < stairs[i].children[j].children.length; k++) {
          steps.push(stairs[i].children[j].children[k]);
        }
      }
    }
    let intersections = this.raycaster.intersectObjects(steps);
    if (intersections.length) {
      return intersections[0].distance;
    } else {
      return(null);
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/services/distance-helper.service.ts